import { NextPage } from 'next';
import React from 'react';

import useIsAuthEnabled from '@jpp/hooks/useIsAuthEnabled';
import PageHandler from '@jpp/shared/PageHandler';
import Auth from '@jpp/templates/Auth';
import { EAuthPage } from '@jpp/templates/Auth/Auth';
import { EPageType } from 'common/typings/enums';

const LoginPage: NextPage = () => {
  const isAuthEnabled = useIsAuthEnabled();
  return isAuthEnabled ? (
    <PageHandler
      template={Auth}
      pageType={EPageType.Auth}
      page={{
        title: 'Login',
        authPage: EAuthPage.Login,
      }}
    />
  ) : null;
};

export default LoginPage;
